/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {NgForOf, NgIf} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

import {Router} from '@angular/router';

import {NbButtonModule, NbCardModule, NbIconModule, NbWindowService} from '@nebular/theme';
import {BaseComponent, DamItemVersion, DamRelatedCollection, Product, SortingPosition} from 'compob2b-libs';
import {Config} from 'compob2b-table';
import {takeUntil} from 'rxjs/operators';
import {DamSearchModalComponent} from '../dam-search-modal/dam-search-modal.component';
import {SecuredImageComponent} from '../secured-image/secured-image.component';

@Component({
  standalone: true,
  selector: 'app-dam-related-collection',
  imports: [
    SecuredImageComponent,
    NbIconModule,
    NbButtonModule,
    NbCardModule,
    NgIf,
    NgForOf
  ],
  templateUrl: './dam-related-collection.component.html'
})
export class DamRelatedCollectionComponent extends BaseComponent implements OnInit {

  @Input() uri: string;
  @Input() model: Product;
  @Input() damRelatedCollection: DamRelatedCollection;

  damItemVersions: DamItemVersion[];

  inputFormControl: FormControl;
  configuration: Config;

  constructor(protected readonly route: Router,
              protected readonly winddowService: NbWindowService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getCollectionData();
  }

  getCollectionData() {
    this.compoApiService
      .get<DamItemVersion[]>(this.uri + '/collections/' + this.model.id + '/' + this.damRelatedCollection.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.damItemVersions = response.data;
        this.cdr.detectChanges();
      });
  }

  showSearchDamModal() {
    const windowModal = this.winddowService.open(DamSearchModalComponent, {
      title: 'Выбор версии версии элемента для привязки: ' + this.damRelatedCollection.header,
      context: {
        modelId: this.model.id,
        uri: this.uri,
        damRelatedCollectionId: this.damRelatedCollection.id
      }
    });
    const mapRouteInfo = windowModal.componentInstance;
    mapRouteInfo.reloadCollection.subscribe(event => {
      // being able to subscribe to "onSomeAction" and get its data to use
      this.getCollectionData();
    });
  }

  removeVersionFromDamCollection(damItemVersionId: number, damRelatedCollectionId: number) {
    this.compoApiService
      .post(this.uri + '/remove-dam-version-from-dam-collection', {
        damItemVersionId,
        modelId: this.model.id,
        damRelatedCollectionId
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(_ => {
        this.successToast('Связь удалена');
        this.getCollectionData();
      });
  }

  related(event) {
    this.getCollectionData();
  }

  drop(event: CdkDragDrop<any>) {
    // this.spinner.show('innerSpinner');
    console.log(event);
    const prevIndex = event.previousContainer.data.index;
    const targetIndex = event.container.data.index;
    console.log(this.damItemVersions);
    this.widgetsMove(this.damItemVersions, prevIndex, targetIndex);

    console.log(this.damItemVersions);
    this.damItemVersions.forEach((value, idx) => value.pos = idx);
    // this.updatePicturesPositions();
  }

  widgetsMove(arr: any, fromIndex: number, toIndex: number) {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
  }

  updatePicturesPositions() {
    const uri = this.uri + '/items-sorting/' + this.model.id + '/' + this.damRelatedCollection.id;
    const sortingPositions: SortingPosition[] = [];
    this.damItemVersions.forEach(picture => sortingPositions.push({id: picture.id, pos: picture.pos}));
    this.compoApiService.post(uri, sortingPositions).pipe(takeUntil(this.unsubscribe)).subscribe(_ => {
    }, error => this.handleError(error));
  }

}
